import { render, staticRenderFns } from "./RescheduleDataTable.vue?vue&type=template&id=52166b52&scoped=true"
import script from "./RescheduleDataTable.vue?vue&type=script&lang=js"
export * from "./RescheduleDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52166b52",
  null
  
)

export default component.exports